import { useTranslate } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Input } from 'module/ui/components/atoms/input/input';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { Form, InputRef } from 'antd';
import { FC, useCallback, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const FormItem = styled(Form.Item)`
  margin-bottom: 0;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  padding: var(--spacing-02);
  width: 304px;
  .ant-form {
    flex: 1;
  }
`;
const TitleIcon = styled(FontAwesomeIcon)`
  color: var(--icon-secondary);
`;

interface FolderTitleInputProps {
  value: string;
  onChange?: (value: string) => void;
  className?: string;
}
export const FolderTitleInput: FC<FolderTitleInputProps> = ({
  className,
  value,
  onChange,
}) => {
  const translate = useTranslate();
  const folderTitlePlaceholderText = translate(
    'knowledge_base.folder.title.placeholder',
  );
  const [form] = Form.useForm<{ folderTitle: string }>();
  const inputRef = useRef<InputRef>(null);
  const onAddOptionInputKeyDown = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.key === 'Enter') {
        form
          .validateFields()
          .then(({ folderTitle }) => {
            onChange?.(folderTitle);
          })
          .catch(() => {});
      }
    },
    [form, onChange],
  );
  const onAddOptionInputBlur = useCallback(() => {
    form
      .validateFields()
      .then(({ folderTitle }) => {
        onChange?.(folderTitle);
      })
      .catch(() => {
        form.setFields([
          {
            name: 'folderTitle',
            errors: [],
          },
        ]);
      });
  }, [form, onChange]);

  useEffect(() => {
    form.setFieldsValue({
      folderTitle: value,
    });
  }, [form, value]);

  return (
    <InputWrapper>
      <TitleIcon icon={faPage} size={32} iconSize={16} color="transparent" />
      <Form
        layout="vertical"
        onSubmitCapture={(event) => {
          event.preventDefault();
        }}
        form={form}
        initialValues={{
          folderTitle: '',
        }}
        className={className}
      >
        <FormItem
          name={'folderTitle'}
          rules={[
            {
              required: true,
              message: <FormattedMessage id="input.required" />,
            },
          ]}
        >
          <Input
            placeholder={folderTitlePlaceholderText}
            onKeyDown={onAddOptionInputKeyDown}
            onBlur={onAddOptionInputBlur}
            ref={inputRef}
          />
        </FormItem>
      </Form>
    </InputWrapper>
  );
};
